import { render, staticRenderFns } from "./EventPresentation.vue?vue&type=template&id=095868ab&scoped=true&"
import script from "./EventPresentation.vue?vue&type=script&lang=ts&"
export * from "./EventPresentation.vue?vue&type=script&lang=ts&"
import style0 from "./EventPresentation.vue?vue&type=style&index=0&id=095868ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095868ab",
  null
  
)

export default component.exports